// Giorni mancanti alla scadenza (negativo se scaduto); null se data assente/non valida.
export function giorniAllaScadenza(v) {
  const m = String(v || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const end = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((end - today) / 86400000);
}

export const inAvviso = (abb) => {
  const g = giorniAllaScadenza(abb?.data_scadenza);
  return g != null && g <= (abb?.avviso_giorni || 30) ? g : null;
};

export const testoScadenza = (g) =>
  g < 0 ? `Abbonamento scaduto da ${-g} ${-g === 1 ? "giorno" : "giorni"}` : g === 0 ? "L'abbonamento scade oggi" : `L'abbonamento scade tra ${g} ${g === 1 ? "giorno" : "giorni"}`;
